import React, { useEffect } from 'react'
import { Box, Button, Grid } from '@material-ui/core'

import {
  ConfigStep,
  ConfirmStep,
  DetailsStep,
  ParticipantsStep,
  ScheduleStep,
  Stepper,
  TemplateStep,
} from './components'

import usePhishing from 'hooks/usePhishing'
import theme from 'theme'
import constants from 'constants/index'

const STEP_COMPONENTS = [
  <ConfigStep />,
  <ParticipantsStep />,
  <TemplateStep />,
  <ScheduleStep />,
  <ConfirmStep />,
]

const STEP_COMPONENTS_VIEW = [<DetailsStep />, ...STEP_COMPONENTS]

const Form = () => {
  const {
    activeStep,
    activeButton,
    showButtons,
    handleAdvanceStep,
    handleNext,
    handleReturnStep,
    isReadOnly,
    wantsToAdvanceStep,
    wantsToReturnStep,
    handleBack,
    resetReturnStep,
  } = usePhishing()

  useEffect(() => {
    if (wantsToReturnStep) {
      handleBack()
      resetReturnStep()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToReturnStep])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stepper />
      </Grid>

      <Grid item xs={12}>
        <Box mt={3} />
        {(isReadOnly ? STEP_COMPONENTS_VIEW : STEP_COMPONENTS)[activeStep]}
      </Grid>

      {showButtons && (
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={theme.spacing(2)}
            mt={3}
          >
            <Button variant="outlined" onClick={handleReturnStep}>
              Voltar
            </Button>
            {isReadOnly &&
              activeStep < constants.phishing.FORM_STEPS_VIEW.length - 1 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  Avançar
                </Button>
              )}
            {!isReadOnly && (
              <Button
                variant="contained"
                color="primary"
                disabled={wantsToAdvanceStep || !activeButton}
                onClick={handleAdvanceStep}
              >
                {constants.phishing.FORM_STEP_LABELS[activeStep]}
              </Button>
            )}
          </Box>
        </Grid>
      )}
    </Grid>
  )
}

export default Form
